module.exports = __webpack_public_path__ + "media/images/favicon/ms-icon-70x70-d69e365a7382a22dcc40771b016c8117.png";